import { render, staticRenderFns } from "./link-tab.vue?vue&type=template&id=fc494bb8&"
import script from "./link-tab.vue?vue&type=script&lang=js&"
export * from "./link-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports